// 获取元素的相关信息
export function getMatrix3dArray( elem ){

    let matrix_3d_string = window.getComputedStyle( elem ).transform;

    if ( matrix_3d_string.toLowerCase().indexOf('matrix3d') === -1 )
        throw new Error('can not read matrix3d string');

    return matrix_3d_string
        .split('(').pop()
        .split(')').shift()
        .split(',').map( v => parseFloat(v) );
}

export function getElementSize( elem ){
    return {
        w : elem.getBoundingClientRect().width,
        h : elem.getBoundingClientRect().height
    };
}

export function getTransformFuncValue( transform_string , func_name ){

    let func_pattern = new RegExp(func_name + '\\((.+?)\\)');  //   'func(a)'
    return func_pattern.exec( transform_string ) &&   // [ 'func(a)' , 'a' ]
           func_pattern.exec( transform_string )[1];
}
// 获取元素的相关信息 END

// 改变元素属性相关方法

export function placeElement( label_elem, target_position , shift ) {

    shift = shift || {
        x : 0 ,
        y : 0
    }

    label_elem.style.left = target_position.x + shift.x  + 'px';
    label_elem.style.top = target_position.y + shift.y + 'px';

    return label_elem;
}

export function scaleElement( label_elem , scale_ratio ) {
    label_elem.style.width = label_elem.getBoundingClientRect().width * scale_ratio + 'px';
}

export function rotate3dElement( label_elem, roll_deg , pitch_angle , yaw_angle , perspective ) {
    label_elem.style.transform =
            'perspective('+ perspective +'px) ' +
            'rotateZ('+ roll_deg +'deg) ' +
            'rotateX('+ pitch_angle +'deg) '  +
            'rotateY('+ yaw_angle +'deg) ';
    return label_elem
}

export function skewElement( element , skew , reverse ) {

    let scale = reverse || { // 判断是否需要反转
        x : 1 ,
        y : 1
    }
    let revere_scale = 'scale(' + scale.x + ',' + scale.y + ') ';

    skew = skew || {
        x : 0 ,
        y : 0
    }

    element.style.transform = 'skew(' + skew.x +'rad,'+ skew.y + 'rad) ' + revere_scale;

    return element
}

export function transformFunc(elem ,func_name, new_value ){

    var origin_transform = elem.style.transform;

    if ( ! new_value ) {
        return getTransformFuncValue( origin_transform , func_name );
    } else {
        return elem.style.transform = setTransformFunc( origin_transform , func_name , new_value );
    }
}

export function setTransformFunc( transform_string , func_name , value ) {
    var func_pattern = new RegExp(func_name + '\\(.+?\\)');
    var split_arr = transform_string.split( func_pattern );
    var new_func = func_name + '(' + value +')';
        split_arr.splice( 1 , 0 , new_func );

    return split_arr.join('');
}

export function setElementHeight( elem , height ) {
    elem.style.height = height + 'px';
}

export function setElementWidth( temple_elem , temple_width ) {
    temple_elem.style.width = temple_width + 'px';
}

export function resetResourceStyle( elem ){
    elem.style.transform = '';
    elem.style.height = '';
    elem.style.width = '';
    elem.style.left = '100%';
    elem.style.top = '100%';
}

export function hide( elem ){
    if ( elem instanceof HTMLElement ) {
        elem.style.opacity = 0;
    }
}

export function show( elem ){
    if ( elem instanceof HTMLElement ) {
        elem.style.opacity = 1;
    }
}

/**
 * 修正 absolute 偏移，如果有居中的
 * @param  {HTMLElemnt} asset_elem
 * @param  {HTMLElement} user_img_elem
 * @return {void}
 */
export function fixAbsoluteShift(  asset_elem , user_img_elem  ){
    asset_elem.style.top = parseInt( asset_elem.style.top ) + user_img_elem.offsetTop + 'px';
    asset_elem.style.left = parseInt( asset_elem.style.left ) + user_img_elem.offsetLeft + 'px';
}
// 改变元素属性相关方法 END

// 改变元素行为
export function preventDefault( elem , event_name ){
    elem.addEventListener( event_name , e => e.preventDefault() , false );
}


